"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listtableData = exports.listtableColumnHeads = exports.slimTableColumnHeads = exports.slimTableData = void 0;
var slimTableData = [{
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "1274",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.25",
  "DISPLAY_REVENUE": "0.32",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "1064",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.67",
  "DISPLAY_REVENUE": "0.71",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "430",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.31",
  "DISPLAY_REVENUE": "0.13",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "23",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.26",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_mobile_300x250_3",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "13",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.32",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "2836",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.5",
  "DISPLAY_REVENUE": "1.41",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "3560",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.25",
  "DISPLAY_REVENUE": "0.91",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "172",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "0.03",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "205",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.66",
  "DISPLAY_REVENUE": "0.13",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "1734",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.57",
  "DISPLAY_REVENUE": "1.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "409",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.34",
  "DISPLAY_REVENUE": "0.14",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "150",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.25",
  "DISPLAY_REVENUE": "0.03",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "331",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.25",
  "DISPLAY_REVENUE": "0.08",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "3046",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.44",
  "DISPLAY_REVENUE": "1.34",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_300x250_3",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "49",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.31",
  "DISPLAY_REVENUE": "0.01",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_mobile_300x250_3",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "1",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.58",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "15",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.56",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "2819",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.31",
  "DISPLAY_REVENUE": "0.87",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_320x50_inview",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "5",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.39",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "48",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "0.01",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "34",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.6",
  "DISPLAY_REVENUE": "0.02",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "32",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.47",
  "DISPLAY_REVENUE": "0.01",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_320x50_inview",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "14",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.32",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_300x250_3",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "27",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.35",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "26",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "2102",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.34",
  "DISPLAY_REVENUE": "0.73",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "80",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.44",
  "DISPLAY_REVENUE": "0.03",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "66",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.31",
  "DISPLAY_REVENUE": "0.02",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "11",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.25",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "4521",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "1.01",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_EMBED_MOBILE",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "211",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.58",
  "DISPLAY_REVENUE": "0.12",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_300x250_5",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "1279",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "0.28",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "343",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.46",
  "DISPLAY_REVENUE": "0.15",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_web_728x90_1",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "349",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.22",
  "DISPLAY_REVENUE": "0.07",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Morocco",
  "AD_UNIT": "allkpop.com_mobile_300x250_6",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "61",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.35",
  "DISPLAY_REVENUE": "0.02",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_728x90_inview",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "18",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.23",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "allkpop.com_web_728x90_inview",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "31",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.26",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "allkpop.com_EMBED_DESKTOP",
  "VIDEO_REVENUE": "0.0",
  "DISPLAY_IMPRESSION": "378",
  "VIDEO_CPM": "0.0",
  "DISPLAY_CPM": "0.44",
  "DISPLAY_REVENUE": "0.16",
  "VIDEO_IMPRESSION": "0"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.13",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "5.61",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "24"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Australia",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.17",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "5.11",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "35"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.02",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "4.36",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "5"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.11",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "4.36",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "26"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Australia",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.15",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "3.78",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "41"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.01",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "6.39",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "3"
}, {
  "DATE": "2019-10-01",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "MOBILE",
  "GEO": "Austria",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.02",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "4.28",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "5"
}, {
  "DATE": "2019-10-02",
  "SITE": "http://www.allkpop.com",
  "DEVICE": "DESKTOP",
  "GEO": "Austria",
  "AD_UNIT": "video",
  "VIDEO_REVENUE": "0.01",
  "DISPLAY_IMPRESSION": "0",
  "VIDEO_CPM": "7.11",
  "DISPLAY_CPM": "0.0",
  "DISPLAY_REVENUE": "0.0",
  "VIDEO_IMPRESSION": "2"
}];
exports.slimTableData = slimTableData;
var slimTableColumnHeads = {
  "DATE": "Date",
  "SITE": "Site",
  "DEVICE": "Device",
  "GEO": "Country",
  "AD_UNIT": "Ad Unit",
  "VIDEO_REVENUE": "Video Revenue",
  "DISPLAY_IMPRESSION": "Display Impressions",
  "VIDEO_CPM": "Video CPM",
  "DISPLAY_CPM": "Display CPM",
  "DISPLAY_REVENUE": "Display Revenue",
  "VIDEO_IMPRESSION": "Video Impressions"
};
exports.slimTableColumnHeads = slimTableColumnHeads;
var listtableColumnHeads = {
  "total": "",
  "2019-08-01": "Aug 1",
  "2019-08-02": "Aug 2",
  "2019-08-03": "Aug 3",
  "2019-08-04": "Aug 4",
  "2019-08-05": "Aug 5",
  "2019-08-06": "Aug 6",
  "2019-08-07": "Aug 7",
  "2019-08-08": "Aug 8",
  "2019-08-09": "Aug 9",
  "2019-08-10": "Aug 10",
  "2019-08-11": "Aug 11",
  "2019-08-12": "Aug 12",
  "2019-08-13": "Aug 13",
  "2019-08-14": "Aug 14",
  "2019-08-15": "Aug 15",
  "2019-08-16": "Aug 16",
  "2019-08-17": "Aug 17",
  "2019-08-18": "Aug 18",
  "2019-08-19": "Aug 19",
  "2019-08-20": "Aug 20",
  "2019-08-21": "Aug 21",
  "2019-08-22": "Aug 22",
  "2019-08-23": "Aug 23",
  "2019-08-24": "Aug 24",
  "2019-08-25": "Aug 25",
  "2019-08-26": "Aug 26",
  "2019-08-27": "Aug 27",
  "2019-08-28": "Aug 28",
  "2019-08-29": "Aug 29",
  "2019-08-30": "Aug 30",
  "2019-08-31": "Aug 31"
};
exports.listtableColumnHeads = listtableColumnHeads;
var listtableData = [{
  "2019-08-01": "20,212",
  "2019-08-02": "17,639",
  "2019-08-03": "11,349",
  "2019-08-04": "631,253",
  "2019-08-05": "16,689",
  "2019-08-06": "14,333",
  "2019-08-07": "6,656",
  "2019-08-08": "35,446",
  "2019-08-09": "8,495",
  "2019-08-10": "56,808",
  "2019-08-11": "49,514",
  "2019-08-12": "69,491",
  "2019-08-13": "82,126",
  "2019-08-14": "80,826",
  "2019-08-15": "63,026",
  "2019-08-16": "86,820",
  "2019-08-17": "106,224",
  "2019-08-18": "156,005",
  "2019-08-19": "69,645",
  "2019-08-20": "508,177",
  "2019-08-21": "0",
  "2019-08-22": "59",
  "2019-08-23": "313",
  "2019-08-24": "233",
  "2019-08-25": "268",
  "2019-08-26": "78,169",
  "2019-08-27": "173",
  "2019-08-28": "213",
  "2019-08-29": "151",
  "2019-08-30": "289",
  "2019-08-31": "316",
  "total": "Total"
}, {
  "2019-08-01": "20,212",
  "2019-08-02": "17,639",
  "2019-08-03": "11,349",
  "2019-08-04": "631,253",
  "2019-08-05": "16,689",
  "2019-08-06": "14,333",
  "2019-08-07": "6,656",
  "2019-08-08": "35,446",
  "2019-08-09": "8,495",
  "2019-08-10": "56,808",
  "2019-08-11": "49,514",
  "2019-08-12": "69,491",
  "2019-08-13": "82,126",
  "2019-08-14": "80,826",
  "2019-08-15": "63,026",
  "2019-08-16": "86,820",
  "2019-08-17": "106,224",
  "2019-08-18": "156,005",
  "2019-08-19": "69,645",
  "2019-08-20": "508,177",
  "2019-08-21": "0",
  "2019-08-22": "59",
  "2019-08-23": "313",
  "2019-08-24": "233",
  "2019-08-25": "268",
  "2019-08-26": "78,169",
  "2019-08-27": "173",
  "2019-08-28": "213",
  "2019-08-29": "151",
  "2019-08-30": "289",
  "2019-08-31": "316",
  "total": "http://www.allkpop.com"
}];
exports.listtableData = listtableData;